import clsx from 'clsx';

interface IErrorMessageProps {
  className?: string;
  text?: string;
}

export const ErrorMessage = (props: IErrorMessageProps) => {
  if (!props.text) return null;
  return <div className={clsx('text-xs text-[#e42d34]', props.className)}>* {props.text}</div>;
};
